import { Flex, FlexItem, Avatar, Button } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

export const VacantRoleOption = ({
  label,
  vacantRoleLabel = "Vacant role",
}) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%">
      <FlexItem flex="1 1 auto">
        <Avatar
          sizing="small"
          title={vacantRoleLabel}
          initials={vacantRoleLabel[0]}
        />
      </FlexItem>
      <Button small>{label}</Button>
    </Flex>
  );
};

VacantRoleOption.propTypes = {
  label: PropTypes.string,
  vacantRoleLabel: PropTypes.string,
};
